const privacyTranslations = {
  pt: {
  title: "Política de Privacidade – Kito",
  sections: [
    {
      heading: "1. Identificação e Compromisso",
      content: [
        "A **KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA**, inscrita sob as leis brasileiras e sediada em São Paulo/SP, assume o compromisso de proteger a privacidade dos usuários do ecossistema Kito (App e Games). Esta política detalha como tratamos dados em conformidade com a LGPD."
      ]
    },
    {
      heading: "2. Informações Coletadas",
      content: [
        "Coletamos dados necessários para a prestação dos serviços, divididos em:",
        "<ul><li><strong>Dados de Cadastro:</strong> Nome e e-mail do responsável legal e nome de usuário (pseudônimo) da criança;</li><li><strong>Dados de Uso:</strong> Progresso de leitura, conquistas no Kito Games e preferências de idioma;</li><li><strong>Interações com IA:</strong> Prompts e escolhas feitas durante as histórias interativas para personalização da narrativa;</li><li><strong>Dados de Parceiros (ISPs):</strong> Informações de validação de vouchers para usuários que acessam via provedores de internet.</li></ul>",
        "Não coletamos dados biométricos ou informações sensíveis de menores de idade."
      ]
    },
    {
      heading: "3. Uso das Informações",
      content: [
        "As informações são processadas exclusivamente para:",
        "<ul><li>Personalizar a experiência literária e o nível de dificuldade dos jogos;</li><li>Processar a IA literária (Google Gemini) para gerar finais alternativos;</li><li>Garantir a segurança da conta e suporte técnico;</li><li>Validar a posse definitiva de livros digitais conforme o plano contratado.</li></ul>"
      ]
    },
    {
      heading: "4. Tratamento de Dados de Crianças e Adolescentes",
      content: [
        "O Kito é uma plataforma para o público infantil e juvenil. Em estrita observância ao Art. 14 da LGPD:",
        "<ul><li>O tratamento de dados de crianças é realizado com o **consentimento específico e em destaque** fornecido por pelo menos um dos pais ou pelo responsável legal no momento da criação da conta;</li><li>Coletamos apenas o mínimo necessário para a atividade, sem condicionar a participação em jogos ou leituras ao fornecimento excessivo de informações.</li></ul>"
      ]
    },
    {
      heading: "5. Compartilhamento com Terceiros",
      content: [
        "O compartilhamento ocorre apenas para viabilizar o serviço:",
        "<ul><li><strong>Provedores de Nuvem e IA:</strong> Firebase (armazenamento) e Google Gemini (processamento de IA de forma anônima);</li><li><strong>Provedores de Internet (ISPs):</strong> Apenas dados necessários para conferência de elegibilidade e faturamento de pacotes de serviços;</li><li><strong>Lojas de Aplicativos:</strong> Google Play e App Store para gestão de assinaturas.</li></ul>"
      ]
    },
    {
      heading: "6. Segurança e Armazenamento",
      content: [
        "Adotamos medidas técnicas de segurança, como criptografia de ponta a ponta e servidores seguros (Google Cloud), para proteger os dados contra acessos não autorizados ou incidentes de segurança."
      ]
    },
    {
      heading: "7. Uso de Inteligência Artificial e Privacidade",
      content: [
        "As interações com a IA do Kito são projetadas para serem seguras. Os dados enviados para processamento de narrativas são desvinculados de identidades reais, garantindo que a tecnologia seja usada apenas para enriquecimento pedagógico e criativo."
      ]
    },
    {
      heading: "8. Direitos do Usuário (Titular)",
      content: [
        "O responsável legal pode, a qualquer momento, através das configurações do app ou e-mail de suporte:",
        "<ul><li>Acessar, corrigir ou anonimizar dados;</li><li>Solicitar a exclusão definitiva da conta e de todos os dados associados;</li><li>Revogar o consentimento para o tratamento de dados.</li></ul>"
      ]
    },
    {
      heading: "9. Alterações nesta Política",
      content: [
        "Podemos atualizar esta política conforme a evolução do nosso ecossistema. Alterações que impactem o consentimento dos pais serão notificadas de forma destacada no aplicativo."
      ]
    },
    {
      heading: "10. Contato e Encarregado de Dados (DPO)",
      content: [
        'Para exercer seus direitos ou tirar dúvidas, entre em contato com nosso Encarregado de Dados pelo e-mail: <a href="mailto:contato@kito.app.br">contato@kito.app.br</a>.'
      ]
    }
  ]
},

  en: {
  title: "Privacy Policy – Kito",
  sections: [
    {
      heading: "1. Identification and Commitment",
      content: [
        "**KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA**, established under Brazilian law and headquartered in São Paulo/SP, is committed to protecting the privacy of users within the Kito ecosystem (App and Games). This policy details how we handle data in compliance with the General Data Protection Law (LGPD) and international best practices."
      ]
    },
    {
      heading: "2. Information Collected",
      content: [
        "We collect data necessary for the provision of services, categorized as:",
        "<ul><li><strong>Registration Data:</strong> Name and email of the legal guardian and a username (pseudonym) for the child;</li><li><strong>Usage Data:</strong> Reading progress, achievements in Kito Games, and language preferences;</li><li><strong>AI Interactions:</strong> Prompts and choices made during interactive stories to personalize the narrative;</li><li><strong>Partner Data (ISPs):</strong> Voucher validation information for users accessing through internet service providers.</li></ul>",
        "We do not collect biometric data or sensitive information from minors."
      ]
    },
    {
      heading: "3. Use of Information",
      content: [
        "The information is processed exclusively to:",
        "<ul><li>Personalize the literary experience and the difficulty level of the games;</li><li>Process the literary AI (Google Gemini) to generate alternative endings;</li><li>Ensure account security and provide technical support;</li><li>Validate the definitive ownership of digital books according to the contracted plan.</li></ul>"
      ]
    },
    {
      heading: "4. Processing of Children's and Adolescents' Data",
      content: [
        "Kito is a platform for children and young people. In strict compliance with child protection laws:",
        "<ul><li>The processing of children's data is performed with <strong>specific and highlighted consent</strong> provided by at least one parent or legal guardian at the time of account creation;</li><li>We collect only the minimum necessary data for the activity, without conditioning participation in games or reading on the provision of excessive information.</li></ul>"
      ]
    },
    {
      heading: "5. Sharing with Third Parties",
      content: [
        "Sharing occurs only to enable the service:",
        "<ul><li><strong>Cloud and AI Providers:</strong> Firebase (storage) and Google Gemini (anonymized AI processing);</li><li><strong>Internet Service Providers (ISPs):</strong> Only data necessary for eligibility verification and billing of service packages;</li><li><strong>App Stores:</strong> Google Play and App Store for subscription management.</li></ul>"
      ]
    },
    {
      heading: "6. Security and Storage",
      content: [
        "We adopt technical security measures, such as end-to-end encryption and secure servers (Google Cloud), to protect data against unauthorized access or security incidents."
      ]
    },
    {
      heading: "7. Artificial Intelligence and Privacy",
      content: [
        "Interactions with Kito's AI are designed to be safe. Data sent for narrative processing is decoupled from real identities, ensuring the technology is used solely for pedagogical and creative enrichment."
      ]
    },
    {
      heading: "8. User Rights (Data Subject)",
      content: [
        "The legal guardian may, at any time, through the app settings or support email:",
        "<ul><li>Access, correct, or anonymize data;</li><li>Request the permanent deletion of the account and all associated data;</li><li>Revoke consent for data processing.</li></ul>"
      ]
    },
    {
      heading: "9. Changes to this Policy",
      content: [
        "We may update this policy as our ecosystem evolves. Changes impacting parental consent will be prominently notified within the application."
      ]
    },
    {
      heading: "10. Contact and Data Protection Officer (DPO)",
      content: [
        'To exercise your rights or ask questions, please contact our Data Protection Officer via email: <a href="mailto:contato@kito.app.br">contato@kito.app.br</a>.'
      ]
    }
  ]
},

  es: {
  title: "Política de Privacidad – Kito",
  sections: [
    {
      heading: "1. Identificación y Compromiso",
      content: [
        "**KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA**, constituida bajo las leyes brasileñas y con sede en São Paulo/SP, asume el compromiso de proteger la privacidad de los usuarios del ecosistema Kito (App y Games). Esta política detalla cómo tratamos los datos en conformidad con la Ley General de Protección de Datos (LGPD) y las mejores prácticas internacionales."
      ]
    },
    {
      heading: "2. Información Recopilada",
      content: [
        "Recopilamos los datos necesarios para la prestación de los servicios, divididos en:",
        "<ul><li><strong>Datos de Registro:</strong> Nombre y correo electrónico del responsable legal y nombre de usuario (seudónimo) del niño;</li><li><strong>Datos de Uso:</strong> Progreso de lectura, logros en Kito Games y preferencias de idioma;</li><li><strong>Interacciones con IA:</strong> Prompts y elecciones realizadas durante las historias interactivas para la personalización de la narrativa;</li><li><strong>Datos de Socios (ISPs):</strong> Información de validación de vales (vouchers) para usuarios que acceden a través de proveedores de internet.</li></ul>",
        "No recopilamos datos biométricos ni información sensible de menores de edad."
      ]
    },
    {
      heading: "3. Uso de la Información",
      content: [
        "La información se procesa exclusivamente para:",
        "<ul><li>Personalizar la experiencia literaria y el nivel de dificultad de los juegos;</li><li>Procesar la IA literaria (Google Gemini) para generar finales alternativos;</li><li>Garantizar la seguridad de la cuenta y el soporte técnico;</li><li>Validar la posesión definitiva de libros digitales según el plan contratado.</li></ul>"
      ]
    },
    {
      heading: "4. Tratamiento de Datos de Niños y Adolescentes",
      content: [
        "Kito es una plataforma para el público infantil y juvenil. En estricta observancia de las leyes de protección del menor:",
        "<ul><li>El tratamiento de datos de niños se realiza con el <strong>consentimiento específico y destacado</strong> proporcionado por al menos uno de los padres o por el responsable legal al momento de crear la cuenta;</li><li>Recopilamos solo lo mínimo necesario para la actividad, sin condicionar la participación en juegos o lecturas a la entrega excesiva de información.</li></ul>"
      ]
    },
    {
      heading: "5. Intercambio con Terceros",
      content: [
        "El intercambio de datos ocurre solo para viabilizar el servicio:",
        "<ul><li><strong>Proveedores de Nube e IA:</strong> Firebase (almacenamiento) y Google Gemini (procesamiento de IA de forma anónima);</li><li><strong>Proveedores de Internet (ISPs):</strong> Solo los datos necesarios para la verificación de elegibilidad y facturación de paquetes de servicios;</li><li><strong>Tiendas de Aplicaciones:</strong> Google Play y App Store para la gestión de suscripciones.</li></ul>"
      ]
    },
    {
      heading: "6. Seguridad y Almacenamiento",
      content: [
        "Adoptamos medidas técnicas de seguridad, como el cifrado de extremo a extremo y servidores seguros (Google Cloud), para proteger los datos contra accesos no autorizados o incidentes de seguridad."
      ]
    },
    {
      heading: "7. Inteligencia Artificial y Privacidad",
      content: [
        "Las interacciones con la IA de Kito están diseñadas para ser seguras. Los datos enviados para el procesamiento de narrativas se desvinculan de identidades reales, garantizando que la tecnología se utilice únicamente para el enriquecimiento pedagógico y creativo."
      ]
    },
    {
      heading: "8. Derechos del Usuario (Titular)",
      content: [
        "El responsable legal puede, en cualquier momento, a través de la configuración de la app o el correo electrónico de soporte:",
        "<ul><li>Acceder, corregir o anonimizar datos;</li><li>Solicitar la eliminación definitiva de la cuenta y de todos los datos asociados;</li><li>Revocar el consentimiento para el tratamiento de datos.</li></ul>"
      ]
    },
    {
      heading: "9. Cambios en esta Política",
      content: [
        "Podemos actualizar esta política a medida que evolucione nuestro ecosistema. Los cambios que afecten el consentimiento de los padres serán notificados de forma destacada en la aplicación."
      ]
    },
    {
      heading: "10. Contacto y Delegado de Protección de Datos (DPO)",
      content: [
        'Para ejercer sus derechos o resolver dudas, póngase en contacto con nuestro Delegado de Protección de Datos por correo electrónico: <a href="mailto:contato@kito.app.br">contato@kito.app.br</a>.'
      ]
    }
  ]
},

};

export default privacyTranslations;
